"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoopRequestDenied = exports.isCoopRequestApproved = exports.isCoopRequestSent = exports.getIsDeniedCoopRequest = exports.getIsApprovedCoopRequest = exports.getIsCoopRequest = exports.restoreOrder = exports.softDeleteOrder = exports.deleteOrder = exports.updateOrder = exports.makeProperUpdateOrderModel = exports.getInitialOrderStatus = exports.getOrderItemsMessages = exports.getItemProductTypeDescription = exports.getUnitedAPIItemsFromOrder = exports.processUnitedAPIOrderV2 = exports.processUnitedAPIOrder = exports.getItemsCoopTotal = exports.getOrderItemBySKU = exports.getOrderItemsByMediaId = exports.setCoopTotalForOrderV2 = exports.getCoopTotalForOrderV2 = exports.getCoopTotalForOrder = exports.getCoopAmountsForOrder = exports.getOrderBalance = exports.getPaymentSubtotal = exports.getItemsSubtotal = exports.getItemSubtotal = exports.processCard = exports.confirmCoopCommitment = exports.processCoopWithoutConfirmation = exports.processCoop = exports.getStatus = exports.getPaymentStatus = exports.getServiceFromVendorId = exports.getOrderPaymentStatus = exports.getOrderItemsFromItems = void 0;
var tslib_1 = require("tslib");
var _1 = require(".");
var interfaces_1 = require("@monorepo/interfaces");
var __1 = require("..");
var httpTxInfo_1 = require("../http/httpTxInfo");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var keycloak_1 = require("../infra/keycloak");
var cloneDeep_1 = (0, tslib_1.__importDefault)(require("lodash/cloneDeep"));
var getOrderItemsFromItems = function (items) {
    var _a;
    var orderItems = [];
    for (var _i = 0, _b = items.products; _i < _b.length; _i++) {
        var productItem = _b[_i];
        var selectedVariant = productItem.product.variants[productItem.selectedVariantIndex];
        var price = _1.CartHelper.getProductPrice(productItem);
        var orderItemProduct = {
            title: productItem.product.title,
            description: productItem.product.description,
            thumbnailUrl: selectedVariant.media[0],
            sku: productItem.product.sku,
            mediaIdACB: productItem.product.mediaIdACB,
            vendor: interfaces_1.Vendor.PURE,
            type: productItem.product.type,
            selectedVariant: {
                title: (_a = selectedVariant.title) !== null && _a !== void 0 ? _a : productItem.product.title,
                deliveryMethod: productItem.selectedDeliveryMethodIndex,
                pieceCount: productItem.selectedDeliveryMethodIndex === __1.DeliveryMethod.PRINT
                    ? selectedVariant.printAndShipOptions[productItem.selectedPrintAndShipIndex].pieceCount
                    : 1,
                size: selectedVariant.size,
            },
        };
        var orderItem = {
            product: orderItemProduct,
            quantity: productItem.quantity,
            price: price.toString(),
            status: 1,
            trackingInformation: [],
            messages: [],
            dealerName: productItem.dealerName,
            dealerAddress: productItem.dealerAddress,
            dealerAddress2: productItem.dealerAddress2,
            dealerPhone: productItem.dealerPhone,
            notes: productItem.notes,
        };
        orderItems.push(orderItem);
    }
    for (var _c = 0, _d = items.events; _c < _d.length; _c++) {
        var eventItem = _d[_c];
        var orderItemProduct = {
            title: eventItem.event.title,
            description: eventItem.event.description,
            thumbnailUrl: "".concat(process.env.PUBLIC_URL).concat(_1.EventHelper.getImageFile(eventItem.event.categories[0])),
            sku: eventItem.event.sku,
            mediaIdACB: eventItem.event.mediaIdACB,
            vendor: interfaces_1.Vendor.DSI,
            type: 3,
        };
        var orderItem = {
            product: orderItemProduct,
            quantity: eventItem.quantity,
            price: eventItem.event.price,
            status: 1,
            trackingInformation: [],
            messages: [],
        };
        orderItems.push(orderItem);
    }
    return orderItems;
};
exports.getOrderItemsFromItems = getOrderItemsFromItems;
var getOrderPaymentStatus = function (items, orderPaidAmount, hasPayments) {
    var eventsOrderTotal = _1.CartHelper.getEventSubtotal(items.events);
    var productsOrderTotal = _1.CartHelper.getProductSubtotal(items.products);
    if ((0, __1.roundCurrency)(eventsOrderTotal + productsOrderTotal - orderPaidAmount) === 0)
        return __1.OrderPaymentStatus.PAID;
    if ((0, __1.roundCurrency)(eventsOrderTotal + productsOrderTotal - orderPaidAmount) > 0) {
        if (hasPayments)
            return __1.OrderPaymentStatus.PARTIAL;
        return __1.OrderPaymentStatus.UNPAID;
    }
};
exports.getOrderPaymentStatus = getOrderPaymentStatus;
var getServiceFromVendorId = function (vendor) {
    switch (vendor) {
        case interfaces_1.Vendor.DSI:
            return 'AUTHORIZE.NET';
        case interfaces_1.Vendor.PURE:
            return 'STRIPE';
    }
};
exports.getServiceFromVendorId = getServiceFromVendorId;
var getPaymentStatus = function (paymentStatus) {
    switch (paymentStatus) {
        case 1:
            return 'UNPAID';
        case 2:
            return 'PARTIAL';
        case 3:
            return 'PAID';
    }
    return 'UNKNOWN';
};
exports.getPaymentStatus = getPaymentStatus;
var getStatus = function (status) {
    switch (status) {
        case 1:
            return 'In Progress';
        case 2:
            return 'Complete';
        case 3:
            return 'Canceled';
        case 4:
            return 'Fulfilled';
        case 5:
            return 'Deleted';
        case 6:
            return 'Pending Co-Op Request';
    }
    return 'Unknown';
};
exports.getStatus = getStatus;
var getAuthorizationHeaders = function () {
    var token = __1.KeycloakHelper.getToken(keycloak_1.keycloakClient);
    if (!token) {
        console.log('[OrderHelper] Authorization header missing');
        return undefined;
    }
    var headers = {
        Authorization: "Bearer ".concat(token),
    };
    console.log('[OrderHelper] Authorization header', headers.Authorization);
    return headers;
};
var getAxiosAuthConfig = function () {
    var headers = getAuthorizationHeaders();
    return headers ? { headers: headers } : {};
};
var processCoop = function (paymentRequest) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var masterDealerId, vendorId, total, mediaId, orderNumber;
    return (0, tslib_1.__generator)(this, function (_a) {
        masterDealerId = paymentRequest.masterDealerId, vendorId = paymentRequest.vendorId, total = paymentRequest.total, mediaId = paymentRequest.mediaId, orderNumber = paymentRequest.orderNumber;
        return [2 /*return*/, new Promise(function (resolve, reject) {
                httpTxInfo_1.httpTxInfo
                    .get({
                    url: "/ACB/CommitmentByMasterDealerId/".concat(masterDealerId, "/").concat(vendorId, "/").concat(total, "/").concat(mediaId, "/").concat(orderNumber, "/order"),
                    headers: getAuthorizationHeaders(),
                })
                    .then(function (_a) {
                    var commitmentRequest = _a.data;
                    if (commitmentRequest.ErrorOccured) {
                        reject(commitmentRequest.CommentsReturned);
                    }
                    httpTxInfo_1.httpTxInfo
                        .get({
                        url: "/ACB/CommitmentConfirmation/".concat(commitmentRequest.CommitmentNumber, "/").concat(orderNumber),
                        headers: getAuthorizationHeaders(),
                    })
                        .then(function (_a) {
                        var commitmentConfirmation = _a.data;
                        if (commitmentConfirmation.ErrorOccured) {
                            reject(commitmentConfirmation.CommentsReturned);
                        }
                        var paymentItem = {
                            id: commitmentRequest.CommitmentNumber,
                            amount: commitmentRequest.CommitmentAmount,
                            type: 2,
                            date: new Date().toUTCString(),
                        };
                        resolve(paymentItem);
                    })
                        .catch(function (error) { return reject(error); });
                })
                    .catch(function (error) { return reject(error); });
            })];
    });
}); };
exports.processCoop = processCoop;
var processCoopWithoutConfirmation = function (paymentRequest) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var masterDealerId, vendorId, total, mediaId, orderNumber;
    return (0, tslib_1.__generator)(this, function (_a) {
        masterDealerId = paymentRequest.masterDealerId, vendorId = paymentRequest.vendorId, total = paymentRequest.total, mediaId = paymentRequest.mediaId, orderNumber = paymentRequest.orderNumber;
        return [2 /*return*/, new Promise(function (resolve, reject) {
                httpTxInfo_1.httpTxInfo
                    .get({
                    url: "/ACB/CommitmentByMasterDealerId/".concat(masterDealerId, "/").concat(vendorId, "/").concat(total, "/").concat(mediaId, "/").concat(orderNumber, "/order"),
                    headers: getAuthorizationHeaders(),
                })
                    .then(function (_a) {
                    var commitmentRequest = _a.data;
                    if (commitmentRequest.ErrorOccured) {
                        reject(commitmentRequest.CommentsReturned);
                    }
                    resolve({
                        commitmentNumber: commitmentRequest.CommitmentNumber,
                        orderNumber: orderNumber,
                        amount: commitmentRequest.CommitmentAmount,
                    });
                })
                    .catch(function (error) { return reject(error); });
            })];
    });
}); };
exports.processCoopWithoutConfirmation = processCoopWithoutConfirmation;
var confirmCoopCommitment = function (commitmentInfo) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var commitmentNumber, orderNumber, amount;
    return (0, tslib_1.__generator)(this, function (_a) {
        commitmentNumber = commitmentInfo.commitmentNumber, orderNumber = commitmentInfo.orderNumber, amount = commitmentInfo.amount;
        return [2 /*return*/, new Promise(function (resolve, reject) {
                httpTxInfo_1.httpTxInfo
                    .get({
                    url: "/ACB/CommitmentConfirmation/".concat(commitmentNumber, "/").concat(orderNumber),
                    headers: getAuthorizationHeaders(),
                })
                    .then(function (_a) {
                    var commitmentConfirmation = _a.data;
                    if (commitmentConfirmation.ErrorOccured) {
                        reject(commitmentConfirmation.CommentsReturned);
                    }
                    var paymentItem = {
                        id: commitmentNumber,
                        amount: amount,
                        type: 2,
                        date: new Date().toUTCString(),
                    };
                    resolve(paymentItem);
                })
                    .catch(function (error) { return reject(error); });
            })];
    });
}); };
exports.confirmCoopCommitment = confirmCoopCommitment;
var processCard = function (paymentRequest) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var UPN, masterDealerId, cardNumber, expirationMonth, expirationYear, CCV, amount, invoiceHeader, description, orderId, firstName, lastName, addressLine, city, state, zipCode, vendorId;
    return (0, tslib_1.__generator)(this, function (_a) {
        UPN = paymentRequest.UPN, masterDealerId = paymentRequest.masterDealerId, cardNumber = paymentRequest.cardNumber, expirationMonth = paymentRequest.expirationMonth, expirationYear = paymentRequest.expirationYear, CCV = paymentRequest.CCV, amount = paymentRequest.amount, invoiceHeader = paymentRequest.invoiceHeader, description = paymentRequest.description, orderId = paymentRequest.orderId, firstName = paymentRequest.firstName, lastName = paymentRequest.lastName, addressLine = paymentRequest.addressLine, city = paymentRequest.city, state = paymentRequest.state, zipCode = paymentRequest.zipCode, vendorId = paymentRequest.vendorId;
        return [2 /*return*/, new Promise(function (resolve, reject) {
                httpTxInfo_1.httpTxInfo
                    .post({
                    url: '/Financial/CreateCreditCardTransaction',
                    data: {
                        Service: (0, exports.getServiceFromVendorId)(vendorId),
                        UPN: UPN,
                        MasterDealerId: masterDealerId,
                        CardNumber: cardNumber,
                        ExpirationMonth: expirationMonth,
                        ExpirationYear: expirationYear,
                        CCV: CCV,
                        Amount: amount,
                        InvoiceHeader: invoiceHeader,
                        Description: description,
                        OrderId: orderId,
                        FirstName: firstName,
                        LastName: lastName,
                        AddressLine: addressLine,
                        City: city,
                        State: state,
                        ZipCode: zipCode,
                    },
                    headers: getAuthorizationHeaders(),
                })
                    .then(function (_a) {
                    var creditCartResponse = _a.data;
                    if (creditCartResponse.ErrorOccured) {
                        reject("check payment logs for more info: ".concat(creditCartResponse.AuditGuid));
                    }
                    var paymentItem = {
                        id: creditCartResponse.TransactionId,
                        amount: amount.toString(),
                        type: 1,
                        date: new Date().toUTCString(),
                    };
                    resolve(paymentItem);
                });
            })];
    });
}); };
exports.processCard = processCard;
var getItemSubtotal = function (item) {
    return item ? (0, __1.roundCurrency)(parseFloat(item.price) * item.quantity) : 0.0;
};
exports.getItemSubtotal = getItemSubtotal;
var getItemsSubtotal = function (items) {
    if (!items || !items.length)
        return 0;
    var subtotal = 0;
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        subtotal = (0, __1.roundCurrency)(subtotal + (0, __1.roundCurrency)(parseFloat(item.price) * item.quantity));
    }
    return subtotal;
};
exports.getItemsSubtotal = getItemsSubtotal;
var getPaymentSubtotal = function (payments) {
    var subtotal = 0;
    for (var _i = 0, payments_1 = payments; _i < payments_1.length; _i++) {
        var payment = payments_1[_i];
        subtotal = (0, __1.roundCurrency)(subtotal + parseFloat(payment.amount));
    }
    return subtotal;
};
exports.getPaymentSubtotal = getPaymentSubtotal;
var getOrderBalance = function (order) {
    var balance = (0, __1.roundCurrency)((0, exports.getItemsSubtotal)(order.items) - (0, exports.getPaymentSubtotal)(order.payments));
    return Math.round(balance * 100) / 100;
};
exports.getOrderBalance = getOrderBalance;
var getCoopAmountsForOrder = function (masterDealerId, items) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var products, events, productMediaIds, eventMediaIds, mediaIdPercentages, result, _i, products_1, productItem, _a, events_1, productItem;
    return (0, tslib_1.__generator)(this, function (_b) {
        switch (_b.label) {
            case 0:
                products = items.filter(function (item) { return item.product.type !== 3; });
                events = items.filter(function (item) { return item.product.type === 3; });
                productMediaIds = (0, tslib_1.__spreadArray)([], Array.from(new Set(products.map(function (item) { return item.product.mediaIdACB; }))), true);
                console.log('productMediaIds:');
                console.log(JSON.stringify(productMediaIds));
                eventMediaIds = (0, tslib_1.__spreadArray)([], Array.from(new Set(events.map(function (item) { return item.product.mediaIdACB; }))), true);
                console.log('eventMediaIds:');
                console.log(JSON.stringify(eventMediaIds));
                return [4 /*yield*/, _1.CartHelper.getCoopPercentages(masterDealerId, productMediaIds, eventMediaIds)];
            case 1:
                mediaIdPercentages = _b.sent();
                result = {};
                for (_i = 0, products_1 = products; _i < products_1.length; _i++) {
                    productItem = products_1[_i];
                    console.log("PRODUCT: ".concat(JSON.stringify(productItem)));
                    result[productItem.product.sku] =
                        Math.round(parseFloat(productItem.price) *
                            productItem.quantity *
                            mediaIdPercentages[productItem.product.mediaIdACB] *
                            100) / 100;
                }
                for (_a = 0, events_1 = events; _a < events_1.length; _a++) {
                    productItem = events_1[_a];
                    console.log("PRODUCT: ".concat(JSON.stringify(productItem)));
                    result[productItem.product.sku] =
                        Math.round(parseFloat(productItem.price) *
                            productItem.quantity *
                            mediaIdPercentages[productItem.product.mediaIdACB] *
                            100) / 100;
                }
                return [2 /*return*/, result];
        }
    });
}); };
exports.getCoopAmountsForOrder = getCoopAmountsForOrder;
var getCoopTotalForOrder = function (masterDealerId, items) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var unitedItems, data, e_1;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                unitedItems = (0, exports.getUnitedAPIItemsFromOrder)(items);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessPreCommitment"), { Items: unitedItems, MasterDealerId: masterDealerId }, getAxiosAuthConfig())];
            case 2:
                data = (_a.sent()).data;
                if (data.ErrorOccured) {
                    return [2 /*return*/, 0];
                }
                return [2 /*return*/, parseFloat(data.TotalAmount)];
            case 3:
                e_1 = _a.sent();
                console.log("error: ".concat(JSON.stringify(e_1)));
                return [2 /*return*/, 0];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getCoopTotalForOrder = getCoopTotalForOrder;
var getCoopTotalForOrderV2 = function (masterDealerId, items) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var _items, unitedItems, data, e_2;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _items = (0, cloneDeep_1.default)(items);
                unitedItems = (0, exports.getUnitedAPIItemsFromOrder)(items);
                if (!unitedItems.length) {
                    return [2 /*return*/, _items];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessPreCommitmentV2"), { Items: unitedItems, MasterDealerId: masterDealerId }, getAxiosAuthConfig())];
            case 2:
                data = (_a.sent()).data;
                if (data.ErrorOccured) {
                    return [2 /*return*/, _items];
                }
                return [2 /*return*/, (0, exports.setCoopTotalForOrderV2)(_items, data)];
            case 3:
                e_2 = _a.sent();
                console.log("error: ".concat(JSON.stringify(e_2)));
                return [2 /*return*/, _items];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getCoopTotalForOrderV2 = getCoopTotalForOrderV2;
var setCoopTotalForOrderV2 = function (items, data) {
    if (!Array.isArray(items) || !data || !Array.isArray(data.MediaItems)) {
        return items;
    }
    var sortFn = function (left, right) {
        return (0, exports.getItemSubtotal)(right) - (0, exports.getItemSubtotal)(left);
    };
    var itemsByMediaId = (0, exports.getOrderItemsByMediaId)(items);
    for (var i = 0, l = data.MediaItems.length; i < l; ++i) {
        var mediaItem = data.MediaItems[i];
        if (!mediaItem.ApplyCoop ||
            !mediaItem.InvoiceAmount ||
            !itemsByMediaId[mediaItem.MediaId]) {
            continue;
        }
        var tmpItemsByMediaId = itemsByMediaId[mediaItem.MediaId].sort(sortFn);
        var currentCoop = (0, __1.roundCurrency)(mediaItem.CommitmentAmount);
        for (var _i_ = 0, _l_ = tmpItemsByMediaId.length; currentCoop > 0 && _i_ < _l_; ++_i_) {
            var tmpItem = tmpItemsByMediaId[_i_];
            var tmpItemSKU = tmpItem.product.sku;
            var item = void 0;
            if (!tmpItemSKU || !(item = (0, exports.getOrderItemBySKU)(items, tmpItemSKU))) {
                continue;
            }
            var itemCoop = (0, __1.roundCurrency)((0, exports.getItemSubtotal)(item) * mediaItem.ReimbursmentRate);
            if (itemCoop > currentCoop) {
                itemCoop = currentCoop;
            }
            item.coopUsed = itemCoop;
            item.reimbursmentRate = mediaItem.ReimbursmentRate;
            currentCoop -= itemCoop;
        }
    }
    return items;
};
exports.setCoopTotalForOrderV2 = setCoopTotalForOrderV2;
var getOrderItemsByMediaId = function (items) {
    if (!Array.isArray(items)) {
        return items;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var callbackFn = function (accumulator, currentValue) {
        var mediaId = currentValue.product.mediaIdACB;
        if (!accumulator[mediaId]) {
            accumulator[mediaId] = [];
        }
        accumulator[mediaId].push(currentValue);
        return accumulator;
    };
    return items.reduce(callbackFn, {});
};
exports.getOrderItemsByMediaId = getOrderItemsByMediaId;
var getOrderItemBySKU = function (items, sku) {
    return items === null || items === void 0 ? void 0 : items.find(function (item) { return item.product.sku === sku; });
};
exports.getOrderItemBySKU = getOrderItemBySKU;
var getItemsCoopTotal = function (items) {
    return Array.isArray(items)
        ? items.reduce(function (accumulator, currentValue) {
            return (0, __1.roundCurrency)(accumulator + (currentValue.coopUsed || 0.0));
        }, 0.0)
        : 0.0;
};
exports.getItemsCoopTotal = getItemsCoopTotal;
var processUnitedAPIOrder = function (orderNumber, email, masterDealerId, items, payment, isUsingCoop) {
    var unitedItems = (0, exports.getUnitedAPIItemsFromOrder)(items, orderNumber, isUsingCoop);
    return new Promise(function (resolve, reject) {
        axios_1.default
            .post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessOrder"), {
            Items: unitedItems,
            MasterDealerId: masterDealerId,
            UPN: email,
            CardNumber: payment.cardNumber,
            ExpirationMonth: Number(payment.expirationMonth),
            ExpirationYear: Number(payment.expirationYear),
            CCV: payment.CCV,
            FirstName: payment.billingAddress.firstName,
            LastName: payment.billingAddress.lastName,
            AddressLine: payment.billingAddress.address1,
            City: payment.billingAddress.city,
            State: payment.billingAddress.state,
            ZipCode: payment.billingAddress.zipCode,
            Description: "Order #".concat(orderNumber),
            OrderId: orderNumber,
        }, getAxiosAuthConfig())
            .then(function (_a) {
            var processOrderResponse = _a.data;
            if (processOrderResponse.ErrorOccured) {
                reject([
                    processOrderResponse.ErrorDescription,
                    processOrderResponse.ErrorTransactionDescription,
                ]);
            }
            var payments = [];
            for (var _i = 0, _b = processOrderResponse.Payments; _i < _b.length; _i++) {
                var paymentItem = _b[_i];
                payments.push({
                    id: paymentItem.Id,
                    amount: paymentItem.Amount.toString(),
                    type: paymentItem.PaymentType,
                    date: new Date(paymentItem.date).toUTCString(),
                });
            }
            resolve(payments);
        })
            .catch(function (error) {
            reject(error);
        });
    });
};
exports.processUnitedAPIOrder = processUnitedAPIOrder;
var processUnitedAPIOrderV2 = function (orderNumber, email, masterDealerId, items, payment, isUsingCoop) {
    var unitedItems = (0, exports.getUnitedAPIItemsFromOrder)(items, orderNumber, isUsingCoop);
    return new Promise(function (resolve, reject) {
        axios_1.default
            .post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessOrderV2"), {
            Items: unitedItems,
            MasterDealerId: masterDealerId,
            UPN: email,
            CardNumber: payment.cardNumber,
            ExpirationMonth: Number(payment.expirationMonth),
            ExpirationYear: Number(payment.expirationYear),
            CCV: payment.CCV,
            FirstName: payment.billingAddress.firstName,
            LastName: payment.billingAddress.lastName,
            AddressLine: payment.billingAddress.address1,
            City: payment.billingAddress.city,
            State: payment.billingAddress.state,
            ZipCode: payment.billingAddress.zipCode,
            Description: "Order #".concat(orderNumber),
            OrderId: orderNumber,
        }, getAxiosAuthConfig())
            .then(function (_a) {
            var processOrderResponse = _a.data;
            if (processOrderResponse.ErrorOccured) {
                reject([
                    processOrderResponse.ErrorDescription,
                    processOrderResponse.ErrorTransactionDescription,
                ]);
            }
            var payments = [];
            for (var _i = 0, _b = processOrderResponse.Payments; _i < _b.length; _i++) {
                var paymentItem = _b[_i];
                payments.push({
                    id: paymentItem.Id,
                    amount: paymentItem.Amount.toString(),
                    type: paymentItem.PaymentType,
                    date: new Date(paymentItem.date).toUTCString(),
                });
            }
            resolve(payments);
        })
            .catch(function (error) {
            reject(error);
        });
    });
};
exports.processUnitedAPIOrderV2 = processUnitedAPIOrderV2;
var getUnitedAPIItemsFromOrder = function (items, invoiceNumber, isUsingCoop) {
    if (invoiceNumber === void 0) { invoiceNumber = 0; }
    if (isUsingCoop === void 0) { isUsingCoop = true; }
    var orderItems = [];
    if (!Array.isArray(items)) {
        return orderItems;
    }
    var products = items.filter(function (item) { return item.product.vendor === interfaces_1.Vendor.PURE; });
    var events = items.filter(function (item) { return item.product.vendor === interfaces_1.Vendor.DSI; });
    products.forEach(function (productItem, i) {
        var orderItem = {
            ApplyCoop: isUsingCoop,
            InvoiceAmount: Math.round(parseFloat(productItem.price) * productItem.quantity * 100) /
                100,
            MediaId: productItem.product.mediaIdACB,
            VendorId: _1.CartHelper.getVendorIdFromVendorType(interfaces_1.Vendor.PURE),
            PlanDescription: productItem.product.title,
            IsEvent: false,
        };
        if (invoiceNumber !== 0) {
            orderItem.InvoiceNumber = "".concat(invoiceNumber, ".creative.").concat(i);
        }
        orderItems.push(orderItem);
    });
    events.forEach(function (eventItem, i) {
        var orderItem = {
            ApplyCoop: isUsingCoop,
            InvoiceAmount: Math.round(parseFloat(eventItem.price) * eventItem.quantity * 100) /
                100,
            MediaId: eventItem.product.mediaIdACB,
            VendorId: _1.CartHelper.getVendorIdFromVendorType(interfaces_1.Vendor.DSI),
            PlanDescription: eventItem.product.title,
            IsEvent: true,
        };
        if (invoiceNumber !== 0) {
            orderItem.InvoiceNumber = "".concat(invoiceNumber, ".event.").concat(i);
        }
        orderItems.push(orderItem);
    });
    return orderItems;
};
exports.getUnitedAPIItemsFromOrder = getUnitedAPIItemsFromOrder;
var getItemProductTypeDescription = function (product) {
    var description;
    switch (product === null || product === void 0 ? void 0 : product.vendor) {
        case interfaces_1.Vendor.PURE: {
            description = _1.ProductHelper.getProductTypeDescription(product === null || product === void 0 ? void 0 : product.type);
            break;
        }
        case interfaces_1.Vendor.DSI: {
            description = _1.EventHelper.getEventTypeDescription(product === null || product === void 0 ? void 0 : product.type);
            break;
        }
        default: {
            description = undefined;
        }
    }
    return description;
};
exports.getItemProductTypeDescription = getItemProductTypeDescription;
var getOrderItemsMessages = function (order) {
    return Array.isArray(order === null || order === void 0 ? void 0 : order.items)
        ? order === null || order === void 0 ? void 0 : order.items.reduce(function (messages, item) {
            if (Array.isArray(item.messages)) {
                return (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], messages, true), [item.messages], false);
            }
            else {
                return messages;
            }
        }, [])
        : [];
};
exports.getOrderItemsMessages = getOrderItemsMessages;
var getInitialOrderStatus = function (order) {
    if (order.items &&
        Array.isArray(order.items) &&
        order.items.every(function (x) { var _a, _b; return ((_b = (_a = x === null || x === void 0 ? void 0 : x.product) === null || _a === void 0 ? void 0 : _a.selectedVariant) === null || _b === void 0 ? void 0 : _b.deliveryMethod) === __1.DeliveryMethod.DOWNLOAD; }) === true) {
        return __1.OrderStatus.ARCHIVED;
    }
    return order.status;
};
exports.getInitialOrderStatus = getInitialOrderStatus;
var makeProperUpdateOrderModel = function (order) {
    delete order._id;
    delete order.__v;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete order.customer.userInfo.enabled;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete order.assignee;
    delete order.coopAmount;
    delete order.customer.userInfo;
    return order;
};
exports.makeProperUpdateOrderModel = makeProperUpdateOrderModel;
var updateOrder = function (http, orderId, orderUpdateModel) {
    return http.patch({
        url: "/order/".concat(orderId),
        data: orderUpdateModel,
    });
};
exports.updateOrder = updateOrder;
var deleteOrder = function (http, orderId) {
    return http.delete({
        url: "order/".concat(orderId),
    });
};
exports.deleteOrder = deleteOrder;
var softDeleteOrder = function (http, order, userName) {
    var orderId = order._id;
    var orderUpdateModel = (0, exports.makeProperUpdateOrderModel)((0, cloneDeep_1.default)(order));
    orderUpdateModel.status = __1.OrderStatus.DELETED;
    var historyDesc = userName && userName.trim() !== '' ? "Deleted by ".concat(userName) : "Deleted";
    orderUpdateModel.history = (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], orderUpdateModel.history, true), [
        {
            description: historyDesc,
            date: new Date().toUTCString(),
        },
    ], false);
    return (0, exports.updateOrder)(http, orderId, orderUpdateModel);
};
exports.softDeleteOrder = softDeleteOrder;
var restoreOrder = function (http, order, userName) {
    var orderId = order._id;
    var orderUpdateModel = (0, exports.makeProperUpdateOrderModel)((0, cloneDeep_1.default)(order));
    orderUpdateModel.status = __1.OrderStatus.IN_PROGRESS;
    var historyDesc = userName && userName.trim() !== '' ? "Restored by ".concat(userName) : "Restored";
    orderUpdateModel.history = (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], orderUpdateModel.history, true), [
        {
            description: historyDesc,
            date: new Date().toUTCString(),
        },
    ], false);
    return (0, exports.updateOrder)(http, orderId, orderUpdateModel);
};
exports.restoreOrder = restoreOrder;
var getIsCoopRequest = function (order) {
    var _a;
    return order
        ? order.status === __1.OrderStatus.COOP_REQUEST ||
            ((_a = order.history) === null || _a === void 0 ? void 0 : _a.some(function (h) { return h.description.includes('Co-Op Request'); }))
        : false;
};
exports.getIsCoopRequest = getIsCoopRequest;
var getIsApprovedCoopRequest = function (order) {
    var _a;
    return order
        ? (_a = order.history) === null || _a === void 0 ? void 0 : _a.some(function (h) {
            return h.description.includes('Co-Op Request Approved');
        })
        : false;
};
exports.getIsApprovedCoopRequest = getIsApprovedCoopRequest;
var getIsDeniedCoopRequest = function (order) {
    var _a;
    return order
        ? (_a = order.history) === null || _a === void 0 ? void 0 : _a.some(function (h) { return h.description.includes('Co-Op Request Denied'); })
        : false;
};
exports.getIsDeniedCoopRequest = getIsDeniedCoopRequest;
var isCoopRequestSent = function (order) {
    return (0, exports.getIsCoopRequest)(order) &&
        !(0, exports.getIsApprovedCoopRequest)(order) &&
        !(0, exports.getIsDeniedCoopRequest)(order);
};
exports.isCoopRequestSent = isCoopRequestSent;
var isCoopRequestApproved = function (order) {
    return (0, exports.getIsCoopRequest)(order) && (0, exports.getIsApprovedCoopRequest)(order);
};
exports.isCoopRequestApproved = isCoopRequestApproved;
var isCoopRequestDenied = function (order) {
    return (0, exports.getIsCoopRequest)(order) && (0, exports.getIsDeniedCoopRequest)(order);
};
exports.isCoopRequestDenied = isCoopRequestDenied;
